import { useState } from 'react';
import { seoData } from '../../data/seoData';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      className="py-12 md:py-20 bg-gray-50"
      aria-labelledby="faq-heading"
    >
      <div className="container mx-auto px-4 md:px-6">
        <h2 id="faq-heading" className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-12 text-gray-800">
          Frequently Asked Questions
        </h2>
        <div className="max-w-4xl mx-auto">
          {seoData.faq.map((item, index) => (
            <article key={index} className="mb-4 bg-white rounded-lg shadow-sm">
              <button
                className="w-full text-left p-6 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
                type="button"
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg md:text-xl font-semibold text-gray-800 pr-4">
                    {item.question}
                  </h3>
                  <span
                    className="text-blue-600 text-2xl flex-shrink-0"
                    aria-hidden="true"
                  >
                    {openIndex === index ? '−' : '+'}
                  </span>
                </div>
              </button>
              {openIndex === index && (
                <div
                  id={`faq-answer-${index}`}
                  className="px-6 pb-6"
                  role="region"
                  aria-labelledby={`faq-question-${index}`}
                >
                  <p className="text-gray-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;